import React, { useEffect } from 'react';
import CardLinkOffer from 'core/modules/Instore/CardLinkOffer/CardLinkOffer';
import { useSelector, useDispatch } from 'react-redux';
import { instoreOfferOverlayClick } from 'core/modules/Instore/OffersSection/actions';
import {
  selectInstoreLinkCardIsLoaded, selectInstoreLinkCardResponse,
} from 'core/modules/Instore/CardLinkOffer/selector';
import { selectUserIsIdentified } from 'core/selectors/user';

import './OfferButtonAndCardInfo.scss';

function OfferButtonAndCardInfo({
  offerId, merchantName, merchantNameAndGmid, isLinkedCards, redemptionEndDate,
  expiringSoon, showError, totalCards, cardsAvailable,
  daysToExpire, styleClass,
}) {
  const instoreLinkCardIsLoaded = useSelector(selectInstoreLinkCardIsLoaded);
  const linkCardResponse = useSelector(selectInstoreLinkCardResponse);
  const isUserIdentified = useSelector(selectUserIsIdentified);
  const dispatch = useDispatch();

  useEffect(() => {
    if (instoreLinkCardIsLoaded && (!linkCardResponse || showError)) {
      dispatch(instoreOfferOverlayClick({
        offerId,
        showError: true,
      }));
    }
  }, [linkCardResponse, instoreLinkCardIsLoaded, showError]);

  const getOfferClickHandler = () => {
    dispatch(instoreOfferOverlayClick({
      offerId,
    }));
  };

  const getLinkedButton = () =>
    (
      <div className="mn_linkCardWrap" data-test="rendered-offer-linked-button">
        <button
          className={`mn_button mn_linked ${styleClass || ''} ${
            isLinkedCards && expiringSoon ? 'mn_expiringOffer' : ''
          }`}
        >
          {isLinkedCards && expiringSoon ? 'Expiring soon' : 'Offer linked'}
        </button>
        <p className="mn_daysLeftToShop" data-test="days-left">{daysToExpire} days left to shop</p>
      </div>
    );

  const getLinkOfferInfo = () =>
    (
      <div className="mn_linkCardWrap" data-test="rendered-link-offer-info">
        <CardLinkOffer
          offerId={offerId}
          merchantName={merchantName}
          merchantNameAndGmid={merchantNameAndGmid}
          totalCards={totalCards}
          redemptionEndDate={redemptionEndDate}
          expiringSoon={expiringSoon}
          cardsAvailable={cardsAvailable}
        >
          Link offer
        </CardLinkOffer>
        <p className="mn_cardsAvailableInfo" data-test="cards-available">
          {cardsAvailable} card{cardsAvailable === 1 ? '' : 's'} available
        </p>
      </div>
    );

  const getLoggedInOfferButton = () =>
    (isLinkedCards ? getLinkedButton() : getLinkOfferInfo());

  return (
    <div
      data-gmid-and-merchant-name={merchantNameAndGmid}
      className={`mn_instoreLinkButton ${isUserIdentified ? '' : 'mn_anonymousView'}
      ${styleClass ? 'mn_allOffersMap' : 'mn_offersSection'}`}
    >
      {isUserIdentified ?
        getLoggedInOfferButton() :
        <>
          <button
            className="mn_button mn_secondaryButton mn_getOffer"
            onClick={getOfferClickHandler}
            data-test="rendered-get-offer-button"
          >
            Get offer
          </button>
          <p className="mn_cardsAvailableInfo" data-test="cards-available">0 cards available</p>
        </>
      }
    </div>
  );
}

export default OfferButtonAndCardInfo;
